import { render, staticRenderFns } from "./pickup.vue?vue&type=template&id=b35c70d8&scoped=true&"
import script from "./pickup.vue?vue&type=script&lang=js&"
export * from "./pickup.vue?vue&type=script&lang=js&"
import style0 from "./pickup.vue?vue&type=style&index=0&id=b35c70d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35c70d8",
  null
  
)

export default component.exports